import React from 'react';

export const isValidEmail = (value, allValues, props) => {
  if (value && !/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i.test(value)) {
    return "Please enter a valid email address e.g john@company.com";
  }
  return undefined;
};

export const isValidPhoneNumber = (value, allValues, props) =>
  value && /\(?\d{3}\)?[- ]?\d{3}[- ]?\d{4}$/.test(value) ?
    undefined : 'Please enter a valid phone number';

export const isRequired = value => (value ? undefined : 'Required');


export const confirm =(value, allValues, props) => {
  return value === props.confirmText ? undefined : <div>{`You must enter `}<strong> {props.confirmText} </strong> {` to confirm!`} </div>;
};

export const zipCode = (value, allValues, props) => {
  if (value) {
    let izZip = (new RegExp('[0-9]{5}').test(value));
    if (!izZip) {
      return 'Should be a zip code.';
    }

    return undefined;
  }
};


export const passwordCheck = (value, allValues, props) => {
  if (value) {
    let eight_chars = (new RegExp("^(?=.{8,})")).test(value);
    let oneUpper = (new RegExp("^(?=.*[A-Z])")).test(value);
    let oneLower = (new RegExp("^(?=.*[a-z])")).test(value);
    let oneNumber = (new RegExp("^(?=.*[0-9])")).test(value);

    if (!eight_chars) {
      return 'Password must be eight characters or longer.';
    }
    if (!oneUpper) {
      return 'Password must contain one uppcase character.';
    }
    if (!oneLower) {
      return 'Password must contain one lowecase character';
    }
    if (!oneNumber) {
      return 'Password must contain one number';
    }
  }

  return undefined;
};

export const passwordVerify = (value, allValues, props) => {
  if (value) {
    //console.log(allValues);
    //console.log(value + " === " + allValues.password);
    if (value !== allValues.password) {
      return "Passwords do not match";
    }
  }
  return undefined;
};


// WEBPACK FOOTER //
// ./src/components/ReduxInput/Validators.js